import { IconHighlightedSizeType } from '@kubit/web-ui-components/iconHighlighted/types';
import { AvatarProfileSizeType } from '../../../../../components/avatarProfile/types/avatarProfileSizeType';
import { FONT_WEIGHT } from '../../foundations/typography';
import { TagVariantType, TextVariantType } from '../variants';
export const commonStyles = (FOUNDATIONS) => ({
    rootContainer: {
        display: 'flex',
        flex_direction: 'column',
        gap: FOUNDATIONS.spacing_50,
    },
    mainWrapperWhenExtraAction: {
        display: 'flex',
        width: '100%',
        border_top_left_radius: FOUNDATIONS.radius_250,
        border_top_right_radius: FOUNDATIONS.radius_250,
        border_bottom_left_radius: FOUNDATIONS.radius_00,
        border_bottom_right_radius: FOUNDATIONS.radius_00,
        padding_bottom: FOUNDATIONS.spacing_250,
    },
    mainActionContainer: {
        display: 'flex',
        flex_direction: 'column',
        gap: FOUNDATIONS.spacing_50,
        width: '100%',
        cursor: 'pointer',
        border_top_left_radius: FOUNDATIONS.radius_250,
        border_top_right_radius: FOUNDATIONS.radius_250,
        border_bottom_left_radius: FOUNDATIONS.radius_250,
        border_bottom_right_radius: FOUNDATIONS.radius_250,
    },
    infoContainer: {
        padding: FOUNDATIONS.spacing_250,
        border_top_left_radius: FOUNDATIONS.radius_250,
        border_top_right_radius: FOUNDATIONS.radius_250,
        border_bottom_left_radius: FOUNDATIONS.radius_250,
        border_bottom_right_radius: FOUNDATIONS.radius_250,
        width: '100%',
        display: 'flex',
        align_items: 'center',
        gap: FOUNDATIONS.spacing_150,
        justify_content: 'space-between',
    },
    iconDataContainer: {
        display: 'flex',
        align_items: 'flex-start',
        gap: FOUNDATIONS.spacing_150,
        overflow: 'hidden',
    },
    iconHighlighted: {
        size: IconHighlightedSizeType.SMALL,
    },
    avatarProfile: {
        size: AvatarProfileSizeType.SMALL,
    },
    dataContainer: {
        display: 'flex',
        flex_direction: 'column',
        gap: FOUNDATIONS.spacing_100,
        overflow: 'hidden',
    },
    title: {
        font_variant: TextVariantType.FONT_PARAGRAPH_250,
        color: FOUNDATIONS.color_comp_navigation_navigationstatuscard_font,
        font_weight: FONT_WEIGHT.font_weight_600,
    },
    subtitle: {
        font_variant: TextVariantType.FONT_PARAGRAPH_500,
        color: FOUNDATIONS.color_comp_navigation_navigationstatuscard_font,
        font_weight: FONT_WEIGHT.font_regular,
    },
    tag: {
        variant: TagVariantType.INFORMATIVE,
    },
    chevronIcon: {
        width: '0.5rem',
        height: '0.875rem',
        color: FOUNDATIONS.color_comp_navigation_navigationstatuscard_icon,
    },
    extraInfoContainer: {
        width: '100%',
        border_top_left_radius: FOUNDATIONS.radius_00,
        border_top_right_radius: FOUNDATIONS.radius_00,
        border_bottom_left_radius: FOUNDATIONS.radius_250,
        border_bottom_right_radius: FOUNDATIONS.radius_250,
        padding_left: FOUNDATIONS.spacing_250,
        padding_right: FOUNDATIONS.spacing_250,
        padding_top: FOUNDATIONS.spacing_150,
        padding_bottom: FOUNDATIONS.spacing_150,
        display: 'flex',
        gap: FOUNDATIONS.spacing_150,
        justify_content: 'space-between',
        align_items: 'center',
    },
    labelTitle: {
        font_variant: TextVariantType.FONT_PARAGRAPH_350,
        color: FOUNDATIONS.color_comp_navigation_navigationstatuscard_font,
        font_weight: FONT_WEIGHT.font_regular,
    },
    infoDetail: {
        font_variant: TextVariantType.FONT_PARAGRAPH_400,
        color: FOUNDATIONS.color_comp_navigation_navigationstatuscard_font,
        font_weight: FONT_WEIGHT.font_weight_600,
    },
    actionLinkContainer: {
        border_top_left_radius: FOUNDATIONS.radius_00,
        border_top_right_radius: FOUNDATIONS.radius_00,
        border_bottom_left_radius: FOUNDATIONS.radius_250,
        border_bottom_right_radius: FOUNDATIONS.radius_250,
        padding_left: FOUNDATIONS.spacing_250,
        padding_right: FOUNDATIONS.spacing_250,
        padding_top: FOUNDATIONS.spacing_150,
        padding_bottom: FOUNDATIONS.spacing_150,
        display: 'flex',
        align_items: 'center',
        gap: FOUNDATIONS.spacing_100,
        cursor: 'pointer',
    },
    actionLinkIcon: {
        width: FOUNDATIONS.size_250,
        height: FOUNDATIONS.size_250,
        color: FOUNDATIONS.color_comp_actions_buttontechonly_ghostsecondaryonsurface_default_icon,
    },
    actionLinkText: {
        font_variant: TextVariantType.FONT_PARAGRAPH_400,
        color: FOUNDATIONS.color_comp_actions_buttontechonly_ghostsecondaryonsurface_default_font,
        font_weight: FONT_WEIGHT.font_weight_600,
        text_decoration: 'underline',
    },
});
//# sourceMappingURL=commonStyles.js.map